// Implements: F-IDN-010
/**
 * Where a session's address was placed, as the v3 tables write it: "Lima, Perú", "Perú" without
 * a city, and the caller's "Ubicación desconocida" when the server could not place it. The country
 * name comes from `Intl.DisplayNames` in the platform locale; a code it cannot name is shown as it
 * came rather than throwing.
 */

import type { SessionLocation } from "../../types/api";
import { PLATFORM_LOCALE } from "../../types/locale";

let regions: Intl.DisplayNames | null = null;

function countryName(code: string): string {
  try {
    regions ??= new Intl.DisplayNames(PLATFORM_LOCALE, { type: "region" });
    return regions.of(code) ?? code;
  } catch {
    return code;
  }
}

export function formatLocation(location: SessionLocation | null | undefined, unknown: string): string {
  if (location === null || location === undefined) return unknown;
  const country = countryName(location.country);
  return location.city === null || location.city === "" ? country : `${location.city}, ${country}`;
}
